export enum AuthVia {
  MedmasteryApp = 'medmastery-app',
}

export enum AuthViaStorageKey {
  AuthVia = 'mm_auth_via',
}

export type UserRole = 'member' | 'professional' | 'Group manager' | 'Group owner' | 'Group member';

export enum SubscriptionType {
  trial = 'trial',
  basic = 'basic',
  pro = 'pro',
}

export enum SubscriptionPurchasePlatform {
  WEB = 'web',
  IOS_APP_STORE = 'ios_app_store',
  GOOGLE_PLAY_STORE = 'google_play_store',
}
